module.exports = __webpack_public_path__ + "img/shirt-tank-top.9df5f06c.svg";